let resolvePageInit: (() => void) | null = null
let isResolved = false
let pageInitPromise = buildPromise()

function buildPromise(): Promise<void> {
  isResolved = false

  return new Promise<void>((resolve) => {
    resolvePageInit = () => {
      if (isResolved) return

      isResolved = true
      resolve()
    }
  })
}

// Do not cache the promise returned by waitForPageInit across unrelated work.
// Call it immediately before awaiting so callers observe the current gate.
export function waitForPageInit() {
  return pageInitPromise
}

export function beginPageInitCycle() {
  if (!isResolved) return

  pageInitPromise = buildPromise()
}

export function finishPageInitCycle() {
  resolvePageInit?.()
}

export function resetPageInitForTests() {
  pageInitPromise = buildPromise()
}
